import React, { useState } from 'react';
import { BuildingIcon, MapPinIcon, PhoneIcon, MailIcon, UserIcon, TruckIcon } from 'lucide-react';
export function CustomerInfoStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    dealerName: initialData.dealerName || '',
    dealerContact: initialData.dealerContact || '',
    dealerEmail: initialData.dealerEmail || '',
    dealerPhone: initialData.dealerPhone || '',
    billToCompany: initialData.billToCompany || '',
    billToAddress: initialData.billToAddress || '',
    billToCountry: initialData.billToCountry || '',
    shipToCompany: initialData.shipToCompany || '',
    shipToAddress: initialData.shipToAddress || '',
    shipToCountry: initialData.shipToCountry || '',
    consigneeName: initialData.consigneeName || '',
    consigneeContact: initialData.consigneeContact || '',
    consigneeEmail: initialData.consigneeEmail || '',
    consigneePhone: initialData.consigneePhone || '',
    notifyName: initialData.notifyName || '',
    notifyContact: initialData.notifyContact || '',
    notifyEmail: initialData.notifyEmail || '',
    notifyPhone: initialData.notifyPhone || '',
    ...initialData
  });
  const [sameAsBillTo, setSameAsBillTo] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSameAsBillToChange = e => {
    const checked = e.target.checked;
    setSameAsBillTo(checked);
    if (checked) {
      setFormData({
        ...formData,
        shipToCompany: formData.billToCompany,
        shipToAddress: formData.billToAddress,
        shipToCountry: formData.billToCountry
      });
    }
  };
  const handleBlur = () => {
    onUpdate(formData);
  };
  return <div className="space-y-8" data-id="element-4539">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4540">
        Customer Information
      </div>
      {/* Dealer Information */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4541">
        <div className="flex items-center mb-4" data-id="element-4542">
          <BuildingIcon size={20} className="text-blue-400 mr-2" data-id="element-4543" />
          <h3 className="text-white font-medium" data-id="element-4544">Dealer Information</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4545">
          <div data-id="element-4546">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4547">
              Dealer Name
            </label>
            <input type="text" name="dealerName" value={formData.dealerName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter dealer name" data-id="element-4548" />
          </div>
          <div data-id="element-4549">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4550">
              Contact Person
            </label>
            <input type="text" name="dealerContact" value={formData.dealerContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4551" />
          </div>
          <div data-id="element-4552">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4553">Email</label>
            <input type="email" name="dealerEmail" value={formData.dealerEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email address" data-id="element-4554" />
          </div>
          <div data-id="element-4555">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4556">Phone</label>
            <input type="text" name="dealerPhone" value={formData.dealerPhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone number" data-id="element-4557" />
          </div>
        </div>
      </div>
      {/* Billing and Shipping Information */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4558">
        {/* Bill To */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4559">
          <div className="flex items-center mb-4" data-id="element-4560">
            <MapPinIcon size={20} className="text-blue-400 mr-2" data-id="element-4561" />
            <h3 className="text-white font-medium" data-id="element-4562">Bill To</h3>
          </div>
          <div className="space-y-4" data-id="element-4563">
            <div data-id="element-4564">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4565">
                Company Name
              </label>
              <input type="text" name="billToCompany" value={formData.billToCompany} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter company name" data-id="element-4566" />
            </div>
            <div data-id="element-4567">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4568">
                Address
              </label>
              <textarea name="billToAddress" value={formData.billToAddress} onChange={handleChange} onBlur={handleBlur} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter complete address" data-id="element-4569"></textarea>
            </div>
            <div data-id="element-4570">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4571">
                Country
              </label>
              <input type="text" name="billToCountry" value={formData.billToCountry} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter country" data-id="element-4572" />
            </div>
          </div>
        </div>
        {/* Ship To */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4573">
          <div className="flex items-center justify-between mb-4" data-id="element-4574">
            <div className="flex items-center" data-id="element-4575">
              <TruckIcon size={20} className="text-blue-400 mr-2" data-id="element-4576" />
              <h3 className="text-white font-medium" data-id="element-4577">Ship To</h3>
            </div>
            <div className="flex items-center" data-id="element-4578">
              <input type="checkbox" id="sameAsBillTo" checked={sameAsBillTo} onChange={handleSameAsBillToChange} className="mr-2 h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-4579" />
              <label htmlFor="sameAsBillTo" className="text-sm text-blue-300" data-id="element-4580">
                Same as Bill To
              </label>
            </div>
          </div>
          <div className="space-y-4" data-id="element-4581">
            <div data-id="element-4582">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4583">
                Company Name
              </label>
              <input type="text" name="shipToCompany" value={formData.shipToCompany} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter company name" data-id="element-4584" />
            </div>
            <div data-id="element-4585">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4586">
                Address
              </label>
              <textarea name="shipToAddress" value={formData.shipToAddress} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} rows={3} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter complete address" data-id="element-4587"></textarea>
            </div>
            <div data-id="element-4588">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4589">
                Country
              </label>
              <input type="text" name="shipToCountry" value={formData.shipToCountry} onChange={handleChange} onBlur={handleBlur} disabled={sameAsBillTo} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-slate-700/50 disabled:text-slate-400" placeholder="Enter country" data-id="element-4590" />
            </div>
          </div>
        </div>
      </div>
      {/* Consignee and Notify Party */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4591">
        {/* Consignee */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4592">
          <div className="flex items-center mb-4" data-id="element-4593">
            <UserIcon size={20} className="text-blue-400 mr-2" data-id="element-4594" />
            <h3 className="text-white font-medium" data-id="element-4595">Consignee</h3>
          </div>
          <div className="space-y-4" data-id="element-4596">
            <div data-id="element-4597">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4598">Name</label>
              <input type="text" name="consigneeName" value={formData.consigneeName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter consignee name" data-id="element-4599" />
            </div>
            <div data-id="element-4600">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4601">
                Contact Person
              </label>
              <input type="text" name="consigneeContact" value={formData.consigneeContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4602" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4603">
              <div data-id="element-4604">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4605">
                  Email
                </label>
                <input type="email" name="consigneeEmail" value={formData.consigneeEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email" data-id="element-4606" />
              </div>
              <div data-id="element-4607">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4608">
                  Phone
                </label>
                <input type="text" name="consigneePhone" value={formData.consigneePhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone" data-id="element-4609" />
              </div>
            </div>
          </div>
        </div>
        {/* Notify Party */}
        <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4610">
          <div className="flex items-center mb-4" data-id="element-4611">
            <PhoneIcon size={20} className="text-blue-400 mr-2" data-id="element-4612" />
            <h3 className="text-white font-medium" data-id="element-4613">Notify Party</h3>
          </div>
          <div className="space-y-4" data-id="element-4614">
            <div data-id="element-4615">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4616">Name</label>
              <input type="text" name="notifyName" value={formData.notifyName} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter notify party name" data-id="element-4617" />
            </div>
            <div data-id="element-4618">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4619">
                Contact Person
              </label>
              <input type="text" name="notifyContact" value={formData.notifyContact} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter contact name" data-id="element-4620" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-4621">
              <div data-id="element-4622">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4623">
                  Email
                </label>
                <input type="email" name="notifyEmail" value={formData.notifyEmail} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email" data-id="element-4624" />
              </div>
              <div data-id="element-4625">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4626">
                  Phone
                </label>
                <input type="text" name="notifyPhone" value={formData.notifyPhone} onChange={handleChange} onBlur={handleBlur} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter phone" data-id="element-4627" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}